import "./Features.css";
import Lines from "../../assets/lines-left.png";

const Features = () => {
    return (
        <section className="feature">

            {/* Línea decorativa */}
            <div>
                <img src={Lines} alt="" className="lines-position-left" />
            </div>

            <div className="feature-container">

                <div className="feature-content">

                    <h3>
                        Nuestra esencia es clara: "Innovamos para transformar".
                    </h3>

                    <p>
                        Con un equipo joven, talentoso y apasionado, Vemasmas, bajo el liderazgo de Oscar Fredy González, desarrolla soluciones que responden a los retos más complejos de nuestro entorno social, empresarial y gubernamental.
                    </p>

                    <p>
                        Lo que nos define en Vemasmas es la audacia para ir más allá, romper paradigmas y ofrecer propuestas tecnológicas de alto impacto
                    </p>

                    <button>
                        Ver Más
                        <span>→</span>
                    </button>

                </div>

            </div>

        </section>
    );
};

export default Features;
